import List from './List';
import { gql } from '@apollo/client';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';

export default {
  name: 'market_location_type_position_rate_settings',
  inputShow: gql`
    query marketLocationTypePositionRateSettings(
      $input: MarketLocationTypePositionRateSettingQueryInput
    ) {
      marketLocationTypePositionRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  create: Create,
  edit: Edit,
  show: Show,
  list: List,
  options: {
    group: 'Rates',
    label: 'Market Location Type Position Rate Settings',
    order: 7,
  },
};
